import { mergeAll } from 'ramda';
import state from './state';
import JobEvaluationPollActions from './custom/job-evaluation-poll/actions';
import JobEvaluationPollMutations from './custom/job-evaluation-poll/mutations';

export default {
	state,
	actions: mergeAll([JobEvaluationPollActions]),
	mutations: mergeAll([JobEvaluationPollMutations]),
};



// WEBPACK FOOTER //
// ./src/modules/polls/store/index.js